import { generateObjectId } from "../../objectIdUtils";

const WEBHOOK = {
  name: "",
  api_key: "",
  app_auth: false,
  app_id: "",
  body: {},
  custom_js: "",
  filters: [],
  method: "",
  path: "",
  projections: [],
  rdbms_id: "",
  sm_id: "",
  table_type: "",
  variables: [],
  version: "v1"
};

const WEBHOOK_CONFIG = {
  name: "",
  query_params: [],
  body_params: {},
  path_params: [],
  headers: [],
  job_configs: [],
  api_key: "",
  table_type: "statemachine",
  rdbms_id: "",
  sm_id: "",
  api_keys: {},
  url_path: "",
  zino_auth: false,
  job_trigger_formula: "",
  pre_processing: "",
  post_processing: "",
  version: "v2",
  success: null,
  error: null,
  method: "",
  app_id: ""
};

const HTTP_REQUEST_TEMPLATE = {
  name: "",
  method: "",
  url: "",
  body_date_definition: null,
  body_dynamic_variables: null,
  body_form_data: null,
  body_option: "",
  header_parameters: null,
  http_output_variable_bindings: [
    {
      id: generateObjectId(),
      name: "http_output",
      path: "http_output"
    },
    {
      id: generateObjectId(),
      name: "http_input",
      path: "http_input"
    }
  ],
  permissions: {
    access_templates: null,
    can_reassign: false,
    // community_groups: null,
    copy_parent_reassign: false,
    designations: null,
    groups: null,
    multiSelectionKeyCode: false,
    type: "anyone"
  },
  query_params: [],
  rate_limit: {
    cool_off_interval: "1 minutes",
    duration: "1 minutes",
    max_limit: 20
  }
};

const apiConfig = {
  webhook: WEBHOOK,
  webhook_config: WEBHOOK_CONFIG,
  http_request_templates: HTTP_REQUEST_TEMPLATE
};

export { apiConfig };
